/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonials_Signup_ButtonInputs */

const en_testimonials_signup_button = /** @type {(inputs: Testimonials_Signup_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up today!`)
};

const es_testimonials_signup_button = /** @type {(inputs: Testimonials_Signup_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Regístrate hoy!`)
};

/**
* | output |
* | --- |
* | "Sign up today!" |
*
* @param {Testimonials_Signup_ButtonInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonials_signup_button = /** @type {((inputs?: Testimonials_Signup_ButtonInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonials_Signup_ButtonInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonials_signup_button(inputs)
	return en_testimonials_signup_button(inputs)
});